export const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

export const AUTH_TOKEN_KEY = 'arcana_auth_token';
export const AUTH_USER_KEY = 'arcana_user';
export const AUTH_TENANT_KEY = 'arcana_tenant';
export const AUTH_REDIRECT_KEY = 'arcana_auth_redirect';

export const ADMIN_SIGNIN_PATH = '/admin/signin';
export const TENANT_SIGNIN_PATH = '/signin';

export const ADMIN_DASHBOARD_PATH = '/admin/dashboard';
export const TENANT_DASHBOARD_PATH = '/tenant/dashboard';

export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 20;